import { useTranslation } from 'react-i18next';
import {
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { AppDispatch, RootState } from '../../template/store';
import { useDispatch } from 'react-redux';
import { toggleDocumentHistoryColumnShort } from '../../blDetails/slices/documentHistorySlice';
import { updateBlDetailsRowColumns } from '../../blDetails/slices/blDetailsTable';
import { useSelector } from 'react-redux';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faCopy, faHandPointRight } from '@fortawesome/free-regular-svg-icons';
import { Form } from 'react-bootstrap';
import { useEffect, useState, useRef, useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAsyncDebounce } from 'react-table';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import DataTable from '../../../common/components/DataTable';
import {
  approveRejectPickUp,
  deleveryLocTypeList,
  extensionTypeList,
  getExtensionRequest,
  getInstructionList,
  getOBLDetails,
  getOBLForOverStay,
  getPickUp,
  getReleaseTypeList,
  getReturnTypeList,
  populateExtensionRequest,
  returnLocTypeList,
  saveExtensionRequest,
  savePickUpInstruction,
} from '../../dashboard/actions/instruction';
import {
  faCheck,
  faCircleInfo,
  faEdit,
  faRedo,
  faSave,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { log, profile } from 'console';
import { toast } from 'react-toastify';
import { AESDecrypt } from '../../../../encrypt-util';
import i18next from 'i18next';
import { commonApproveReject } from '../../dashboard/actions/instruction';
import { updateDashbaordRefresh, updateSortStateDataTable } from '../../../common/components/DataTable/slices/DataTable';

import { useBackNavigation } from '../../../../hooks/BackNavigation';
import useDataCountry from '../../../../hooks/useDataCountry';
import { getDateFormat } from '../../../../helpers/dateFormat';
import { IDataTableColumn } from '../../../common/types/dataTable';
import moment from 'moment';
import { updateSelectedDateDV, updateSelectedPickupLocation, updateSelectedTruckerName, updateSelectedtruckerId, updateselectedInternalCode, updateSelectedtruckerCode } from './instructionSlice/DemurrageSlice';
import { clearData, clearTableInputValues, setContainerData, updateNavigateFlag, updateSelectedCCyOnContainer, updateSelectedCcy, updateSelectedContainerNo, updateSelectedDeleveryLocType, updateSelectedDeleveryLocTypeOnContainer, updateSelectedPickupDate, updateSelectedPlannedPickupDate,updateSelectedContainerReturnDate, updateSelectedneedExtensionFor, updateSelectedReturnDate, updateSelectedReturnLocType, updateSelectedReturnLocTypeOnContainer } from './instructionSlice/OverstayExtensionSlice';
import { Item } from 'react-bootstrap/lib/Breadcrumb';
import SnoozedToButton from '../../instructionDashboard/components/SnoozedTo';
import { getCurrencyDDList, getCurrencyDDListByBankNm } from '../../blPayment/actions/payments';
import useBlCountry from '../../../../hooks/useBlCountry';
import InfoDiv from '../../../../components/common/InfoDiv';
import { getCustomersDetailsByPartnerId } from '../../profile/action/ProfileAccount';
import { getUnprefixedPathname } from '../../../../helpers/utils';
import { getUserProfile } from '../../../common/actions/userDetails';
import { useFormNavigationWarning } from '../../../../hooks/useFormNavigationWarning';
import UnsavedChangesModal from '../../../../components/common/UnsavedChangesModal';
import { setDirty } from '../../formDirtySlice';


const OverstayExtensionRequest = () => {
  const { t, i18n } = useTranslation();
  const isDirty = useSelector((state: RootState) => state.formDirty.isDirty);
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { blNum, encryptdoc } = useParams();
  const instructionDashboardList = useSelector(
    (state: RootState) => state.dashboard.instructionDashboardList
  );
  const [isLoadedFromStorage, setIsLoadedFromStorage] = useState(false);
  const dataObl = useSelector((state: RootState) => state.instructionSlice.dataObl)
  const [blNumDisplay, setBlNumDisplay] = useState('');
  const oblNumber = useSelector((x: RootState) => x.oblDetails.oblForm.number)
  const dataInst = useSelector((state: RootState) => state.documentHistory.data)
  const dashboardListArray = Array.isArray(instructionDashboardList)
    ? instructionDashboardList
    : Array.isArray(instructionDashboardList?.result)
      ? instructionDashboardList.result
      : [];
  const matchingInstruction = dashboardListArray.find((item: any) => item.bl_id === AESDecrypt(blNum));

  //  const displayNumber = dataObl?.number || matchingInstruction?.bl_no || '';
  const displayNumber = blNumDisplay ? blNumDisplay : oblNumber ? oblNumber : '';


  const docId = AESDecrypt(encryptdoc);
  const [country, setCountry] = useState<any>(null);
  const [clearable, setClearable] = useState(true);
  const data: any = useSelector((state: RootState) => state.overstay.data);
  console.log(data,'<<data')
  const localstorageFlag: any = useSelector((state: RootState) => state.overstay.localstorage)
  const extensionRequestStatus: any = useSelector((state: RootState) => state.overstay.overstayExtension.status)
  const extensionRequestId: any = useSelector((state: RootState) => state.overstay.overstayExtension.extensionRequestId)
  const extensionReasonData: any = useSelector((state: RootState) => state.overstay.data.map((item) => item.needExtensionFor));
  const blEventId_docInsDashboard: any = useSelector(
    (state: any) => state.dashboard.instructionDashboardList.result.filter((Item: any) => Item.bl_id == AESDecrypt(blNum))[0]?.bl_event_id
  );
  const [extensionTypeError, setExtensionTypeError] = useState("");
  const conatainerData = useSelector((state: RootState) => state.overstay.data)
  const [isEdit, setIsEdit] = useState(false);
  const currencyList = useSelector((state: RootState) => state.standaloneInvoice.countryDDList)
  const [invalidContainers, setInvalidContainers] = useState<string[]>([]);
  const selectedPickupLocation = useSelector(
    (state: RootState) => state.demurrage.selectedPickupLocation
  );
  const [localStorageContainerNo, setLocalStorageContainerNo] = useState<any>()
  const selectedNeedExtensionFor = useSelector(
    (state: RootState) => state.overstay.overstayExtension.needExtensionFor
  );

  const selectedPlannedPickupDate = useSelector((state: RootState) => state.overstay.overstayExtension.plannedPickupDate)
  const pymtConf = useSelector((data: RootState) => data.blPayment.pymtConf);

  const pickUpLocation = useSelector(
    (state: RootState) => state.demurrage.pickUpLocation
  );
  const accessListLiner = ['1', '24118']
  const handleCopyBL = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event from bubbling up
    try {

      if (displayNumber) {
        await navigator.clipboard.writeText(typeof displayNumber === 'string'
          ? displayNumber
          : displayNumber || '');
        //  toast.success(t('resource_2:copiedToClipboard') as string);
      } else {
        toast.error(t('resource_2:copyFailed') as string);
      }
    } catch (error) {
      console.error('Copy failed:', error);
      toast.error(t('resource_2:copyFailed') as string);
    }
  };
  const onBack = useBackNavigation();

  const validateExtensionTypes = () => {

    // Assign extensionTypeOption[0].value if needExtensionFor is 0
    const updatedData = data.map((item: any) => {
      if (item.needExtensionFor === "0" || item.needExtensionFor === 0 || !item.needExtensionFor) {
        return {
          ...item,
          needExtensionFor: extensionTypeOption[0]?.value || ""
        };
      }
      return item;
    });

    const extensionTypes = updatedData
      .filter((item: any) => item.needExtensionFor)
      .map((item: any) => item.needExtensionFor);


    if (extensionTypes.length === 0) {
      setExtensionTypeError("");
      setInvalidContainers([]);
      return true;
    }

    const firstValue = String(extensionTypes[0]);

    const invalidContainersList = updatedData
      .filter(
        (item: any) =>
          item.needExtensionFor &&
          String(item.needExtensionFor) !== firstValue
      )
      .map((item: any) => item.containerNo);

    const allSame = invalidContainersList.length === 0;

    if (!allSame) {
      //   toast.error("Please select either Detention or Demurrage for all containers");
      setInvalidContainers(invalidContainersList);
      return false;
    }

    setExtensionTypeError("");
    setInvalidContainers([]);
    return true;
  };

  console.log("pymtConf",pymtConf.showLinkDemurrageCalculator)

  const TableCell = (rowData: any) => {
    const { blContainerId, containerNo, plannedPickupDate} = rowData.row.original;

    if (disableFields) {
      return (
        <span>
          {plannedPickupDate ? moment(
            moment
              .utc(plannedPickupDate)
              .toDate()
          ).format(getDateFormat().toLocaleUpperCase()) : ''}
        </span>
      );
    }
    return (
      <>
        <DatePicker
          selected={plannedPickupDate}
          portalId='root'
          onChange={(date) => {

            /*  dispatch(
               updateSelectedDateDV({
                 ...selectedDate,
                 [containerNo]: date,
                 intended: null,
               })
             ); */
            dispatch(
              updateSelectedPickupDate({
                containerNo,
                plannedPickupDate: date
              })
            );
            dispatch(setDirty());
          }}
          onBlur={() => setValue('plannedPickupDate', plannedPickupDate, { shouldDirty: false })}
          className='fs--2 form-control'
          timeIntervals={5}
          dateFormat={getDateFormat()}
          isClearable={clearable}

          popperProps={{
            strategy: 'fixed',
          }}
          disabled={
            false
            //  selectedPickupLocation?.[containerNo] === '1001' ? true : false
          }
          minDate={new Date()}
        />
        {/*   {!data?.list
          ?.map((d) => (selectedDate?.[d.containerNo] ? true : false))
          .includes(true) &&
          !selectedDate?.[containerNo] && (
            <span className='text-danger f--1 mt-1'> </span>
          )} */}
      </>
    );
  };
   const TableCell2 = (rowData: any) => {
    const { blContainerId, containerNo, containerReturnDate } = rowData.row.original;
    if (disableFields) {
      return (
        <span>
          {containerReturnDate ? moment(
            moment
              .utc(containerReturnDate)
              .toDate()
          ).format(getDateFormat().toLocaleUpperCase()) : ''}
        </span>
      );
    }
    return (
      <>
        <DatePicker
          // selected={containerReturnDate ? new Date(containerReturnDate) : null}
          selected={containerReturnDate}

          portalId='root'
          onChange={(date:  Date | null) => {

            dispatch(
              updateSelectedReturnDate({
                containerNo,
                containerReturnDate: date
              })
            );
            dispatch(setDirty());
          }}
          onBlur={() => setValue('containerReturnDate', containerReturnDate, { shouldDirty: false })}
          className='fs--2 form-control'
          timeIntervals={5}
          dateFormat={getDateFormat()}
          isClearable={clearable}
          popperProps={{
            strategy: 'fixed',
          }}
          disabled={
            false
            
          }
          minDate={new Date()}
        />
   
      </>
    );
  };


  {
    extensionTypeError && (
      <div className="col-12 mb-2">
        <div className="alert alert-danger" role="alert">
          {extensionTypeError}
        </div>
      </div>
    )
  }
  const TableCellReturnLocation = (rowData: any) => {
    const { containerNo, needExtensionFor } = rowData.row.original;
    const isInvalid = invalidContainers.includes(containerNo);

    if (!disableFields) {
      return (
        <Form.Select
          disabled={disableFields}
          value={needExtensionFor || ''}
          onChange={(e) => {
            const value = e.target.value;
            dispatch(setDirty());
            // Dispatch the Redux update
            dispatch(
              updateSelectedContainerNo({
                containerNo,
                needExtensionFor: value
              })
            );
          }}

          className={`fs--1 form-control form-select ${isInvalid ? "border-danger" : ""}`}
          style={isInvalid ? { borderColor: "red", boxShadow: "0 0 0 0.2rem rgba(220, 53, 69, 0.25)" } : {}}
        >
          {
            <>
              {extensionTypeOption.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </>
          }
        </Form.Select>
      );
    } else {
      return <span>{extensionTypeOption?.find?.((i) => i.value == needExtensionFor)?.text || ''}</span>;
    }
  };
  const TableCellDeleveryLocType = (rowData: any) => {
    const { blContainerId, containerNo, deliveryLocationType, needExtensionFor } = rowData.row.original;
    if (!disableFields) {
      return (
        <Form.Select
          disabled={disableFields}
          value={deliveryLocationType || ''}
          onChange={(e) => {
            dispatch(setDirty());
            dispatch(
              updateSelectedDeleveryLocTypeOnContainer({
                containerNo,
                deliveryLocationType: e.target.value
              })
            );


          }}
          className='fs--1 form-control  form-select'>
          {
            <>
              {deleveryLocationList?.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </>
          }
        </Form.Select>
      );
    } else {
      return (
        <span>

          {deleveryLocationList?.find?.((i) => i.value == deliveryLocationType)?.text || ''}
        </span>
      );
    }
  };


   const TableCellReturnLocType = (rowData: any) => {
    const { blContainerId, containerNo, returnLocation, needExtensionFor } = rowData.row.original;
    if (!disableFields) {
      return (
        <Form.Select
          disabled={disableFields}
          value={returnLocation || ''}
          onChange={(e) => {
            dispatch(setDirty());
            dispatch(
              updateSelectedReturnLocTypeOnContainer({
                containerNo,
                returnLocation: e.target.value
              })
            );


          }}
          className='fs--1 form-control  form-select'>
          {
            <>
              {returnTypeList?.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </>
          }
        </Form.Select>
      );
    } else {
      return (
        <span>

          {returnTypeList?.find?.((i) => i.value == returnLocation)?.text || ''}
        </span>
      );
    }
  };

  const TableCellCurrency = (rowData: any) => {
    const { blContainerId, containerNo, currency } = rowData.row.original;
    if (!disableFields) {
      return (
        <Form.Select
          disabled={disableFields}
          value={currency || ''}
          onChange={(e) => {
            dispatch(setDirty());
            dispatch(
              updateSelectedCCyOnContainer({
                containerNo,
                currency: e.target.value
              })
            );


          }}
          className='fs--1 form-control  form-select'>
          <option key={''} value={''}></option>
          {currencyList.map((option: any) => (
            <option key={option.currencyCode} value={option.currencyCode}>
              {option.currencyShortName}
            </option>
          ))}


        </Form.Select>
      );
    } else {
      return (
        <span>

          {currency}
        </span>
      );
    }
  };


  /*   const dataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  ); */
  const linerDataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  );
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );

  //const dataCountry = useDataCountry();

  const rbac = useSelector((state: RootState) => state.userProfile);
  const extensionTypeOption = useSelector(
    (state: RootState) => state.overstay.extensionTypeOptions
  );

  const deleveryLocationList = useSelector(
    (state: RootState) => state.overstay.deleveryTypeLocation
  );

    const returnTypeList = useSelector(
    (state: RootState) => state.overstay.returnTypeLocation
  );

  const destuffingTpList = useSelector(
    (state: RootState) => state.pickup.destuffingTpList
  );


  const pickUpForm = useSelector((state: RootState) => state.pickup.pickUpData);

  const selectedLinerId = useSelector(
    (state: RootState) => state.navbarTop.linerId
  );
  console.log(selectedLinerId, '<<selectedLinerId')

  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const disabledPath = [

    {
      path: `${APP_PATH_PREFIX}/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[3] !== 'instruction',
    },
    {
      path: `${APP_PATH_PREFIX}/instruction/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[4] !== 'instruction',
    },
    {
      path: `${APP_PATH_PREFIX}/payment/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[4] !== 'instruction',
    },
    { path: `${APP_PATH_PREFIX}/instruction/:blNum/:encrypt/:encryptdoc` },
  ].some(({ path, condition }: { path: string; condition?: boolean }) => {
    return (
      (condition ?? true) &&
      matchPath({ path, caseSensitive: true, end: true }, location.pathname)
    );
  });

  const dataCountry = useDataCountry();

  const [blCountry, setBlCountry] = useBlCountry(
    disabledPath ? "view" : "new",
    "import",
    816
  );

  const showCurrency =
      blCountry == 'KE' || blCountry == 'CI' || blCountry == 'TG' || blCountry == 'BJ' || blCountry == 'LK'
      || blCountry == 'UG' || blCountry == 'MZ'
      || (selectedLinerId == '24118' && (blCountry == 'CM' || blCountry == 'CG' || blCountry == 'ZA' ));

  console.log(blCountry, '<<blCountry')

  const recentId = useSelector((state: RootState) => {
    const arr = state?.documentHistory?.data?.filter(
      (inst: any) =>
        inst.instructionId == 816 &&
        (inst.event == 'Submitted' || inst.event == 'Completed') &&
        inst.docStatus !== 'Y' &&
        inst.docStatus !== 'N'
    );
    return arr.length <= 0
      ? null
      : arr.reduce((a: any, b: any) => (a.blEventId > b.blEventId ? a : b));
  });
  const recentIdSubmission = useSelector((state: RootState) => {
    const arr = state?.documentHistory?.data?.filter(
      (inst: any) =>
        inst.instructionId == 816 &&
        (inst.event == 'Submitted') &&
        inst.docStatus !== 'Y' &&
        inst.docStatus !== 'N'
    );
    return arr.length <= 0
      ? null
      : arr.reduce((a: any, b: any) => (a.blEventId > b.blEventId ? a : b));
  });
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId)
  //const onSubmit = handleSubmit(async (payload) => {});

  //const [rejectRemarks, setRejectionRemarks] = useState('');
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const [userRemark, setUserRemark] = useState('');

  type FormValues = {
    needExtensionFor: string;
    deliveryLocationType: string;
    plannedPickupDate: Date | null;
    userRemark: string;
    destuffingTp: string;
    returnLoc: string;
    rejectRemarks: string;
    status: string;
    customerCode: string; // Now optional
    requesterEmail: string;
    ccy: string;
    // New fields
    companyName: string;
    address: string;
    emailId: string;
    taxId: string;
    containerReturnDate: Date | null;
    returnLocation: string;


  };
  const validationSchema = Yup.object().shape({
    needExtensionFor: Yup.string().required(
      t('resource_3:isRequired', { field: t('resource_2:releaseType') })
    ),
    //  customerCode: Yup.string(),
    customerCode: Yup.string().trim().when(['$country', '$linerId'], {
      is: (country: string) => {
        return linerId !== '24118' && linerId != '1'
      },
      then: (schema) => schema.required(
        t('resource_3:isRequired', { field: t('resource_2:customerCode') })
      ),
      otherwise: (schema) => schema.notRequired(),
      // Fixes: Combined both country and linerId checks into a single `.when()` for clarity and correct conditional validation
    }).when(['$country'], {
      is: (country: string) => {
        return linerId === '24118'
      },
      then: (schema) => {
        return schema.matches(
          /^[A-Za-z0-9]*$/,
          t('resource_message:alphanumericOnly', { field: t('resource_2:customerCode') })
        )
      },
      otherwise: (schema) => schema
    }),
    companyName: Yup.string().when('$country', {
      is: 'VN',
      then: (schema) =>
        schema.required(
          t('resource_3:isRequired', { field: t('resource_2:companyName') })
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

    address: Yup.string().when('$country', {
      is: (country: string) => ['VN', 'MZ'].includes(country),
      then: (schema) =>
        schema.required(
          t('resource_3:isRequired', { field: t('resource_1:address') })
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

    emailId: Yup.string()
      .email(t('resource_3:invalidEmail'))
      .when('$country', {
        is: 'VN',
        then: (schema) =>
          schema.required(
            t('resource_3:isRequired', { field: t('resource_2:emailId') })
          ),
        otherwise: (schema) => schema.notRequired(),
      }),

    taxId: Yup.string().when('$country', {
      is: 'VN',
      then: (schema) =>
        schema.required(
          t('resource_3:isRequired', { field: t('resource_2:taxId') })
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

  //   containerReturnDate: Yup.date()
  // .nullable()
  // .required('Container Return Date is required')
  // .typeError('Container Return Date is required'),

  // returnLocation: Yup.string()
  // .required('Return Location is required'),


    containers: Yup.array().of(
      Yup.object({
        containerNo: Yup.string().required(),
        needExtensionFor: Yup.string()
          .test('not-zero', t('resource_3:isRequired', { field: t('resource_3:needExtensionFor') }), v => !!v && String(v) !== '0')
          .required(t('resource_3:isRequired', { field: t('resource_3:needExtensionFor') })),
        plannedPickupDate: Yup.mixed()
          .test('has-date', t('resource_3:isRequired', { field: t('resource_3:plannedPickupDate') }), v => !!v),
      })
    ),
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
    context: { country: profileDetails?.partnerCountry },

  });
  const { showModal, handleNavigation, handleConfirm, handleCancel, handleBack } = useFormNavigationWarning({
    isChanged: isDirty,
    isEditable: true,
    onConfirm: onBack // or onBack, or your navigation function
  });

  const handleStayOnPage = () => {
    handleCancel();
  };

  const handleLeavePage = () => {
    onBack()
  };
  const disableFields = isEdit ? false :
    profileDetails?.partnerType === 'liner' ||
    (!!disabledPath && profileDetails?.partnerType !== 'liner');
  useEffect(() => {
    const storageKey = 'overstayExtensionFormData';
    const data1 = localStorage.getItem(storageKey);
    if (data1) {
      // setIsLoadedFromStorage(true)
      try {
        const parsed = JSON.parse(data1);
        console.log(parsed,"parsed")
        // Get all container numbers from selectedDate
        const containerNos = Object.keys(parsed.selectedDate || {}).filter(key => key !== 'intended');

        // Build array of container objects
        const containerDataForRedux = containerNos.map(containerNo => ({
          id: null,
          containerNo,
          plannedPickupDate: parsed.selectedDate?.[containerNo] ? new Date(parsed.selectedDate[containerNo]) : null,
         containerReturnDate: null,
        returnLocation: '0',
         needExtensionFor: parsed.selectedNeedExtensionFor?.[containerNo] ?? '0',
          deliveryLocationType: deleveryLocationList.some(x => x.value == parsed.selectedPickupLocation?.[containerNo]) ?
            parsed.selectedPickupLocation?.[containerNo] ?? '0' : deleveryLocationList?.[0]?.value ?? '0',
          currency: parsed.currency?.[containerNo] ?? ''
        }));
        /*   containerNos.forEach(containerNo => {
                const value = parsed.selectedPickupLocation?.[containerNo] ?? '0';
                setValue('deliveryLocationType', value, { shouldDirty: true });
                dispatch(updateSelectedDeleveryLocType(value));
              }); */
        if (containerDataForRedux.length > 0) {
          dispatch(setContainerData(containerDataForRedux));
        }

        // Restore other form fields as needed
        /*    if (parsed.senderEmail) setValue('requesterEmail', parsed.senderEmail);
           if (parsed.userRemarks) setValue('userRemark', parsed.userRemarks);
           if (parsed.customerCode) setValue('customerCode', parsed.customerCode); */

        localStorage.removeItem(storageKey);
      } catch (e) {
        console.error("Failed to map data from localStorage", e);
        localStorage.removeItem(storageKey);
      }
    }


  }, [dispatch, disableFields, setValue]);

  useEffect(() => {
    if (!disableFields)
      dispatch(getCustomersDetailsByPartnerId({}))
        .unwrap()
        .then((response: any) => {

          setValue('companyName', response.companyName || '')
          setValue('emailId', response.emailList.emailId || profileDetails.email || '')
          setValue('address', response.address || '')
          setValue('taxId', response.partnerIdentityNo || '')
        })
  }, [])
  useEffect(() => {
    if (!blNum || disableFields) return;

    if (recentIdSubmission) {
      setTimeout(() => {
        toast.info(
          <>
            An <b>Extension Invoice Instruction</b> request already exists. Please review the existing request before submitting a new one.
          </>,
          {
            toastId: 'extension-invoice-exists',
            position: 'top-right',
            autoClose: 10000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            theme: 'dark',
            style: {
              background: '#007bff',
              color: '#fff',
              fontWeight: 500,
              // fontSize: '1rem',   <-- remove this line
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              minWidth: '350px',
              maxWidth: '600px',
              right: '50px',
              top: '50px',
            },
            closeButton: true,
            icon: false,
          }
        );
      }, 2000);
    }

  }, [blNum, docId, dataCountry]);
  useEffect(() => {

    //if(!setIsLoadedFromStorage){
    if (!localstorageFlag) {
      if (blCountry)
        dispatch(extensionTypeList({ partnerCountry: blCountry, linerId })).unwrap().then((data) => {
          if (disabledPath) return
          dispatch(updateSelectedneedExtensionFor(data.value))
        })
    }
    if (blCountry && linerId) {
      dispatch(deleveryLocTypeList({ dataCountry: blCountry, linerId }))
      dispatch(returnLocTypeList({ dataCountry: blCountry, linerId }))

    }

    i18n.changeLanguage(
      `${blCountry}_${language}`
    );
  }, [blCountry, linerId, language]);
  useEffect(() => {
    setCountry(profileDetails.partnerType !== 'liner' ? profileDetails.partnerCountry : dataCountry)
  }, [profileDetails, dataCountry])

  const onSubmit = handleSubmit(async (payload) => {
    console.log('Payload:', payload);
    if (profileDetails.partnerCountry === 'VN') {
      const isValid = validateExtensionTypes();
      if (!isValid) {
        toast.error("Please select either Detention Or Demurrage for all containers");
        return;
      }
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0)
    if (data.filter((item: any) => item.needExtensionFor != 0).find((Item: any) => Item.plannedPickupDate < today)) {
      toast.error("Planned Pickup Date value can not be before current date")
      return
    }

    try {

      dispatch(
        saveExtensionRequest({
          ...payload,
          requestedPartnerId: profileDetails?.partnerId,
          blId: AESDecrypt(blNum),
          extensionRequestId: location.pathname.includes('/bl/') ? recentIdSubmission?.docId : extensionRequestId,
          containerDetails: data.filter((item: any) => item.plannedPickupDate || item.id).map((item: any) => ({
            containerPickupId: item.id,
            cntNo: item.containerNo,
            pickupLocation: (profileDetails.partnerCountry == 'VN' || profileDetails.partnerCountry == 'MZ') && item.needExtensionFor == 0 ? extensionTypeOption[0].value : item.needExtensionFor,
            pickupDate: item.plannedPickupDate && item.needExtensionFor != 0 ? moment(item.plannedPickupDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            truckerName: "",
            deliveryLocationType: blCountry == 'TZ' || blCountry == 'KE' || (blCountry == 'CM' && selectedLinerId == '24118')|| (blCountry == 'CN' && selectedLinerId == '24118') || (blCountry == 'ZA' && selectedLinerId == '24118') || blCountry == 'TG' || blCountry == 'BJ' || blCountry == 'LK' || blCountry=='CI' || blCountry == 'UG' || blCountry == 'MZ' ? item.deliveryLocationType : null,
            returnDate:
              item.containerReturnDate
                ? moment(item.containerReturnDate).format('YYYY-MM-DDTHH:mm:ss')
                : null,
            returnLocation: item?.returnLocation ?? null,
            truckerId: "",
            currency: item.currency || currencyList?.[0]?.currencyCode || payload?.ccy || ''
          })),
          customerEmailId: profileDetails?.email,
          emailId: payload.emailId,
          address: payload.address,
          taxId: payload.taxId,
          remarks: payload.rejectRemarks ?? "",
          customerCode: payload.customerCode,
          status: "S",
          extensionReason: extensionTypeOption?.find?.((i) => i.value == extensionReasonData)?.text || '',
          country: blCountry,
          linerId: linerId,
          shipmentType: 'IMPORT',
          instructionType: 816
        })
      ).unwrap()
        .then((response: any) => {
          toast.success(response?.data?.responseMsg);
          setTimeout(() => {
            dispatch(
              getInstructionList({
                blNum: AESDecrypt(blNum),
                country: profileDetails.partnerType == "liner" ? dataCountry : blCountry
              })
            );
            dispatch(updateDashbaordRefresh(true))
          }, 3500)
          onBack()

        });



    } catch (err: any) {
      console.error(err)
    }
  });

  useEffect(() => {
    //if(!setIsLoadedFromStorage)
    if (!localstorageFlag)
      if (disabledPath && selectedLinerId && docId) {
        dispatch(getExtensionRequest({
          docId,
          selectedLinerId:
            profileDetails.partnerType === 'liner'
              ? profileDetails?.partnerId
              : selectedLinerId,
        })).unwrap().then
          ((r: any) => {
            setBlNumDisplay(r.data?.blNo)
            setBlCountry(r.data?.country)
            setValue('userRemark', r.data?.userRemarks ?? '')
            setValue('status', r.data?.status ?? '')
            setValue('rejectRemarks', r.data?.remarks ?? '')
            setValue('customerCode', r.data?.customerCode ?? '')
            setValue('requesterEmail', r.data?.customerEmailId ?? '')

            setValue('emailId', r.data?.emailId ?? '')
            setValue('taxId', r.data?.taxId ?? '')
            setValue('companyName', r.data?.companyName ?? '')
            setValue('address', r.data?.address ?? '')
            setValue('ccy', r.data?.containerDetails?.[0]?.currency ?? '')
          })

      } else {
        setBlNumDisplay("")
        setValue('needExtensionFor', '0');
        setValue('plannedPickupDate', null)
        setValue('containerReturnDate', null)
        // setValue('returnLocation', '')
        setValue('userRemark', '')
        setValue('destuffingTp', '1');
        setValue('returnLoc', '0');
        setValue('status', '');
        setValue('ccy', '')
        setValue('rejectRemarks', '')
        setValue('customerCode', '')
        setValue('requesterEmail', '')
        dispatch(clearData())
        resetForm()
        //dispatch(updateSelectedPlannedPickupDate(null))
      }
    setIsEdit(false)

  }, [docId, location.pathname, selectedLinerId]);
  useEffect(() => {
    //if(!setIsLoadedFromStorage)
    if (!localstorageFlag && docId)
      dispatch(getExtensionRequest({
        docId,
        selectedLinerId:
          profileDetails.partnerType === 'liner'
            ? profileDetails?.partnerId
            : selectedLinerId,
      })).unwrap().then((r: any) => {

        // First set all values from getExtensionRequest


        setBlNumDisplay(r.data?.blNo)
        setValue('userRemark', r.data?.userRemarks ?? '')
        setValue('status', r.data?.status ?? '')
        setValue('rejectRemarks', r.data?.remarks ?? '')
        setValue('customerCode', r.data?.customerCode ?? '')
        setValue('requesterEmail', r.data?.customerEmailId ?? '')
        setValue('emailId', r.data?.emailId ?? '')
        setValue('taxId', r.data?.taxId ?? '')
        setValue('companyName', r.data?.companyName ?? '')
        setValue('address', r.data?.address ?? '')
        


        // If any required fields are empty, try getUserProfile
        if (!r.data?.emailId || !r.data?.companyName || !r.data?.taxId) {
          dispatch(getUserProfile()).unwrap().then((response: any) => {

            // Only set values that are empty from getExtensionRequest
            if (!r.data?.emailId) {
              setValue('emailId', response?.data?.email ?? '')
            }
            if (!r.data?.companyName) {
              setValue('companyName', response?.data?.partnerName ?? '')
            }
            if (!r.data?.taxId) {
              setValue('taxId', response?.data?.userIdentityNo ?? '')
            }

            // If address is still empty, try getCustomersDetailsByPartnerId
            if (!r.data?.address) {
              dispatch(getCustomersDetailsByPartnerId({}))
                .unwrap()
                .then((fallbackResponse: any) => {

                  // Only set values that are still empty
                  if (!r.data?.address && !response?.data?.address) {
                    setValue('address', fallbackResponse?.address ?? '')
                  }
                  if (!r.data?.taxId && !response?.data?.userIdentityNo) {
                    setValue('taxId', fallbackResponse?.partnerIdentityNo ?? '')
                  }
                })
                .catch((error: Error) => {
                  console.error("Fallback API failed", error)
                })
            }
          })
            .catch((error: Error) => {
              console.error("Primary API failed", error)
            })
        }
      })
  }, []);
  useEffect(() => {
    // if(!setIsLoadedFromStorage)
    if (!localstorageFlag)
      if (!disabledPath || isEdit) {
        if (blNum && selectedLinerId)
          dispatch(
            getOBLForOverStay({
              blNumber: AESDecrypt(blNum) || null,
              selectedLinerId:
                profileDetails.partnerType === 'liner'
                  ? profileDetails?.partnerId
                  : selectedLinerId,
            })
          ).unwrap().then(() => {
            if (recentId)
              dispatch(populateExtensionRequest({
                docId: recentId?.docId,
                selectedLinerId:
                  profileDetails.partnerType === 'liner'
                    ? profileDetails?.partnerId
                    : selectedLinerId,
              })).unwrap().then((payload: any) => {
                setValue('userRemark', payload?.data?.userRemarks)
                setValue('customerCode', payload?.data?.customerCode)

                setValue('emailId', payload?.data?.emailId)
                setValue('companyName', payload?.data?.companyName)
                setValue('address', payload?.data?.address)
                setValue('taxId', payload?.data?.taxId)
              })
          })
      }
  }, [blNum, isEdit, selectedLinerId, recentId]);

  useEffect(() => {
    if (profileDetails.partnerType === 'customer') {
      dispatch(getCurrencyDDList())
    } else if (profileDetails.partnerType === 'liner') {
      dispatch(getCurrencyDDListByBankNm({ country: dataCountry }))
    }
  }, [profileDetails.partnerType])

  const onApproveReject = (status: string, type: string) => {
    if (status && type) {
      if (status === 'R' && (watch('rejectRemarks') === '' || watch('rejectRemarks') == null)) {
        toast.dark(t('resource_message:remarksMandatory'));
      } else {
        dispatch(
          commonApproveReject({
            instructionId: docId ? parseInt(docId) || null : null,
            instructionType: type || null,
            country: blCountry,
            linerRemarks: watch('rejectRemarks') || null,
            customerRemarks: userRemark || null,
            status: status || null,
            customerCode: watch('customerCode') || null,
            shipmentType: 'IMPORT'
          })
        )
          .unwrap()
          .then((response: any) => {
            toast.success(response?.responseMsg);
            dispatch(updateDashbaordRefresh(true))
          })
          .catch((error: any) => {
            toast.error(error);
          });

        //update instruction list and redirect to previous page
        dispatch(
          getInstructionList({
            blNum: AESDecrypt(blNum),
            country: profileDetails.partnerType == "liner" ? dataCountry : blCountry
          })
        );
        onBack()
      }
    }
  };

  const resetForm = () => {
    setValue('needExtensionFor', '0');
    setValue('plannedPickupDate', null);
    setValue('containerReturnDate', null);
    setValue('returnLocation', '0');

    setValue('ccy', '');
    setValue('deliveryLocationType', '0')
    setValue('userRemark', '');
    setValue('customerCode', '');
    setValue('companyName', '');
    setValue('address', '');
    setValue('emailId', '');
    setValue('taxId', '');
    setInvalidContainers([]);
    setExtensionTypeError("");

    dispatch(clearTableInputValues())
  };

  const contactDetailsColumns: IDataTableColumn[] = [
    {
      accessor: 'blContainerId',
      Header: 'blContainerId',
    },
    {
      accessor: 'containerNo',
      Header: t('resource_2:containerNo'),
      width: 200,
      maxWidth: 150,
    },
    {
      accessor: 'needExtensionFor',
      Header: t('resource_3:needExtensionFor'),
      width: 220,
      maxWidth: 220,
      Cell: TableCellReturnLocation,
    },
    {
      accessor: 'IntendedDate',
      Header: t('resource_3:plannedPickupDate'),
      width: 220,
      maxWidth: 220,
      Cell: TableCell,
      //  columnFilterType: 'date-range',
    },
    {
      accessor: 'ReturnDate',
      Header: t('resource_3:returnDate'),
      width: 220,
      maxWidth: 220,
      Cell: TableCell2,
    },
    {
        accessor: 'returnLocation',
        Header: t('resource_3:returnLocation') ,
        width: 220,
        maxWidth: 220,
        Cell: TableCellReturnLocType,
      },
    ['TG','CI', 'UG', 'TZ', 'MZ', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118') || (blCountry == 'CM' && selectedLinerId == '24118') || (blCountry == 'CG' && selectedLinerId == '24118') ?
      {
        accessor: 'deleveryLocType',
        Header: t('resource_3:deleveryLocType'),
        width: 220,
        maxWidth: 220,
        Cell: TableCellDeleveryLocType,
      } : {
        accessor: 'deleveryLocType',
        Header: '',
        width: 0,
        maxWidth: 0,
      },
    {
      accessor: 'currency',
      Header: t('resource_1:currency'),
      width: 220,
      maxWidth: 220,
      Cell: TableCellCurrency,
      //  columnFilterType: 'date-range',
    }



  ];

  const formRef = useRef < HTMLFormElement > (null); // <-- Add form ref


    const getHiddenCols = () => {
    if (['KE', 'UG', 'TZ', 'MZ'].includes(blCountry) && disableFields) {
      return ['blContainerId', 'ReturnDate', 'returnLocation'];
    } 
    else if (blCountry == 'ZA' && selectedLinerId == '24118') {
      return ['blContainerId'];
    }
    else if (blCountry == 'CM' && selectedLinerId == '24118' && disableFields) {
      return ['blContainerId', 'ReturnDate', 'returnLocation'];
    }
    else if (blCountry == 'CG' && selectedLinerId == '24118' && disableFields) {
      return ['blContainerId', 'ReturnDate', 'returnLocation'];
    }
    else {
      return ['blContainerId', 'currency', 'ReturnDate', 'returnLocation'];
    }
  };

  const hiddenCols = useMemo(() => getHiddenCols(), [blCountry, selectedLinerId, disableFields]);



  return (
    <Card style={{ minHeight: '100%' }}>
      <UnsavedChangesModal
        show={showModal}
        onHide={handleStayOnPage}
        onConfirm={handleLeavePage}
      />
      <Card.Header className='d-flex align-items-center flex-wrap border-bottom sticky-top bg-white gap-2'>
        <FontAwesomeIcon
          icon={faArrowAltCircleLeft}
          className='text-warning cursor-pointer fa-lg mb-1 me-1'
          // onClick={onBack}
          onClick={handleBack}
        />

        <div className="d-flex align-items-center flex-wrap mb-2 flex-grow-1">
          <h2 className="fs-0 text-primary mb-1 mb-lg-0">
            {t('resource_3:overstayExtensionRequest')}
          </h2>

          {displayNumber && (
            <div className="d-flex align-items-center ms-3 mt-2 mt-lg-0">
              <span className="text-muted me-2">BL No.</span>
              <span className="fw-bold me-2">
                {displayNumber}
              </span>
              <button
                className="btn btn-link p-0"
                onClick={handleCopyBL}
                title="Copy BL number"
              >
                <FontAwesomeIcon icon={faCopy} className="text-primary" />
              </button>
            </div>
          )}
        </div>

        {blCountry === 'CM' && selectedLinerId === '24118' && (
          <a
            href="https://demurrage.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="ms-auto fs--1 text-primary text-decoration-none d-inline-flex align-items-center gap-1"
          >
            <FontAwesomeIcon
              icon={faHandPointRight}
              style={{ color: '#F37021' }}
            />
            {t('resource_4:demurrageCalculator')}
          </a>
        )}

      </Card.Header>
      <Card.Body>
        <div className='container'>
          {profileDetails.partnerType === 'customer' && selectedLinerId == '1' && (blCountry == 'VN') && (
            <Form.Label className="mb-3">
              <a
                href="https://script.google.com/macros/s/AKfycbzbXM0x5eVu4_dxy0x9-99O0o-tHUMUcYxquoWE6WeG9GoHy-1ckyfvIPu78gwFSRuAQA/exec"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-link p-0"
              >
                Click Here to calculate Demurrage / Detention Charges
              </a>
            </Form.Label >
          )}

          {t('resource_message:extensionMessage') &&
            <div className='col-lg-12 mb-1'>
              <Form.Label style={{ color: '#f5822a' }}>
                {t('resource_message:extensionMessage')}
              </Form.Label>
            </div>}

          <Form ref={formRef} onSubmit={onSubmit} autoComplete='off'>
            <div className='row'>
              {!disableFields ? <div className='col-lg-6 mb-3'>
                <Form.Group controlId='overStayExtension.needExtensionFor'>
                  <Form.Label className='fs--1'>
                    {/*               <span className='mandatory'>*</span> */}
                    {t('resource_5:needExtensionForAllContainer')}&nbsp;
                  </Form.Label>
                  <Form.Select
                    aria-label={t('resource_2:pickUpLoc')}
                    className='fs--1'
                    disabled={disableFields}
                    value={`${watch('needExtensionFor')}`}
                    {...register('needExtensionFor')}
                    onChange={(e) => {
                      dispatch(updateSelectedneedExtensionFor(e.target.value))
                      dispatch(setDirty());
                      setValue('needExtensionFor', e.target.value, { shouldDirty: true });
                    }}
                  >

                    {extensionTypeOption?.map((option: any) => (
                      <option key={option.value} value={option.value}>
                        {option.text}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div> : ""}
              {(!disableFields && ['KE', 'TG','CI', 'UG', 'TZ', 'MZ', 'CM', 'CG','ZA','BJ','LK'].includes(blCountry) && selectedLinerId == '24118') ? <div className='col-lg-6 mb-3'>
                <Form.Group controlId='overStayExtension.deliveryLocationType'>
                  <Form.Label className='fs--1'>
                    {['TG','CI', 'BJ','LK'].includes(blCountry) ? "" : <span className='mandatory'>*</span>}
                    {t('resource_5:deliveryLocationTypeForAllContainer')}&nbsp;
                  </Form.Label>
                  <Form.Select
                    aria-label={t('resource_2:pickUpLoc')}
                    {...register('deliveryLocationType')}
                    className='fs--1'
                    disabled={disableFields}
                    value={`${watch('deliveryLocationType')}`}
                    onChange={(e) => {
                      dispatch(setDirty());
                      dispatch(updateSelectedDeleveryLocType(e.target.value))
                      setValue('deliveryLocationType', e.target.value, { shouldDirty: true })
                    }}
                  >
                    {deleveryLocationList.map((option: any) => (
                      <option key={option.value} value={option.value}>
                        {option.text}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div> : ""}
              {!disableFields ?
                <div className='col-lg-6 mb-3'>
                  <Form.Group controlId='carrierHaulage.IntendedDate'>
                    <Form.Label className='fs--1'>
                      {t('resource_5:plannedPickupDateForAllContainer')}{' '}
                      <FontAwesomeIcon
                        icon={faCircleInfo}

                        title={t('resource_5:calculatationTextDemurrageStorageDetension')}
                        className='me-2'
                      />
                    </Form.Label>
                    <div className='releaseDate'>
                      <DatePicker
                        //  selected={selectedDate?.intended}
                        selected={watch('plannedPickupDate')}
                        onChange={(date: any) => {
                          dispatch(setDirty());
                          dispatch(
                            updateSelectedPlannedPickupDate(date)
                          );
                          setValue('plannedPickupDate', date)
                        }}

                        className='fs--2 form-control'
                        timeIntervals={5}
                        dateFormat={getDateFormat()}
                        isClearable={clearable}
                        popperProps={{
                          strategy: 'fixed',
                        }}
                        minDate={new Date()}
                        //disabled={DatePickDisabled}
                        // setValue={value}

                        disabled={disableFields}
                      />
                    </div>
                  </Form.Group>
                </div> : ""}
              {(!disableFields && ['KE', 'TG','CI', 'UG', 'TZ', 'MZ', 'CM', 'CG','ZA', 'BJ','LK'].includes(blCountry) && selectedLinerId == '24118') ? <div className='col-lg-6 mb-3'>
                <Form.Group controlId='overStayExtension.deliveryLocationType'>
                  <Form.Label className='fs--1'>
                    {['TG','CI', 'BJ','LK'].includes(blCountry) ? "" : <span className='mandatory'>*</span>}
                    {t('resource_5:currencyForAllContainer')}&nbsp;
                  </Form.Label>
                  <Form.Select
                    aria-label={t('resource_2:currency')}
                    {...register('ccy')}
                    className='fs--1'
                    disabled={disableFields}
                    value={`${watch('ccy')}`}
                    onChange={(e) => {
                      dispatch(setDirty());
                      dispatch(updateSelectedCcy(e.target.value))
                      setValue('ccy', e.target.value, { shouldDirty: true })
                    }}
                  >
                    <option key={''} value={''}></option>
                    {currencyList?.map((option: any) => (
                      <option key={option.currencyCode} value={option.currencyCode}>
                        {option.currencyShortName}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div> : ""}


              {(!disableFields && (blCountry ==='ZA' && selectedLinerId ==='24118')) ?
                <div className='col-lg-6 mb-3'>
                  <Form.Group controlId='carrierHaulage.ReturnDate'>
                    <Form.Label className='fs--1'>
                       {/* <span className='mandatory'>*</span>  */}
                 
                      Container Return Date

                    </Form.Label>
                    <div className='releaseDate'>
                      <DatePicker

                        selected={watch('containerReturnDate')}
                        // selected={
                        //   watch('containerReturnDate')
                        //     ? new Date(watch('containerReturnDate') as string | number | Date)
                        //     : null
                        // }
                    // className={`fs--1 form-control ${!!errors.containerReturnDate ? 'is-invalid' : ''}`}

                        onChange={(date: Date | null) => {
                          dispatch(setDirty());
                          dispatch(
                            updateSelectedContainerReturnDate(date)
                          );
                          setValue('containerReturnDate', date)
                        }}

                        className='fs--2 form-control'
                        timeIntervals={5}
                        dateFormat={getDateFormat()}
                        isClearable={clearable}
                        popperProps={{
                          strategy: 'fixed',
                        }}
                        minDate={new Date()}


                        disabled={disableFields}
                      />
                    </div>
                  </Form.Group>
                   {/* <div className='invalid-feedback d-block'>

                {errors.containerReturnDate?.message?.toString()}

              </div> */}
                </div>
                : ""}

            
           {(!disableFields && (blCountry ==='ZA' && selectedLinerId ==='24118')) ? <div className='col-lg-6 mb-3'>
                <Form.Group controlId='overStayExtension.deliveryLocationType'>
                  <Form.Label className='fs--1'>
                     {/* <span className='mandatory'>*</span>  */}
                    
                    Return Location Type
                  </Form.Label>
                  <Form.Select
                    // aria-label={t('resource_2:pickUpLoc')}
                    {...register('returnLocation')}
                    className='fs--1'
                    // className={`fs--1 form-control ${!!errors.returnLocation ? 'is-invalid' : ''}`}
                    // disabled={disableFields}
                    value={`${watch('returnLocation')}`}
                    onChange={(e) => {
                      dispatch(setDirty());
                      dispatch(updateSelectedReturnLocType(e.target.value))
                      setValue('returnLocation', e.target.value, { shouldDirty: true })
                    }}
                  >
                    {returnTypeList?.map((option: any) => (
                      <option key={option.value} value={option.value}>
                        {option.text}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                 {/* <div className='invalid-feedback d-block'>

                {errors.returnLocation?.message?.toString()}

              </div> */}

              </div> : ""}


              <div
                className='col-lg-12 mb-2 demmurageTable'
                style={{ zIndex: 1 }}>
                  {(data?.length > 0 && blCountry && selectedLinerId) && <DataTable
                    data={data}
                    gridName='OVER_INTSRUCTION'
                    columns={contactDetailsColumns}
                    sortable={false}
                    searchable={false}
                    showColumnFilter={false}
                    selection={false}
                    perPage={10}
                    pagination={false}
                    showExport={false}
                    uniqueFilterKey='releaseInstruction'
                  autoHeight={true}
                  staticHiddenCols={hiddenCols}
                  defaultHiddenCols={hiddenCols}
                  // staticHiddenCols={
                  //   ((['KE', 'UG', 'TZ', 'MZ'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118') || (blCountry == 'CM' && selectedLinerId == '24118') || (blCountry == 'CG' && selectedLinerId == '24118')) && disableFields)
                  //     ? ['blContainerId']
                  //     : ['blContainerId', 'currency']}


                

                />}
              </div>
              <div className='col-lg-12 mb-2'>
                <div className='row'>

                  {((['KE', 'TG','CI', 'UG', 'TZ', 'MZ', 'SA', 'BJ','LK'].includes(blCountry)) && selectedLinerId == '1') || blCountry == 'HK' ?
                    "" : <div className='col-lg-4 mb-3'>
                      <Form.Group controlId='invoiceChanges.customerCode'>
                        <Form.Label className='fs--1'>
                          {t('resource_2:customerCode')}&nbsp;
                          {linerId === '1' ? <FontAwesomeIcon
                            icon={faCircleInfo}
                            title='Click on the icon to find your "Customer Code"'
                            className='me-2 cursor-pointer text-primary'
                            onClick={() => {
                              window.open(`/pdf/CustomerCode/${linerId}.pdf`);
                            }}
                          /> : ""}
                        </Form.Label>
                        <Form.Control
                          {...register('customerCode')}
                          className={`fs--1 form-control ${errors.customerCode ? 'is-invalid' : ''}`}
                          type='text'
                          maxLength={country == 'VN' ? 8 : 20}
                          onChange={({ target }) => {
                            if (country == 'VN') {
                              const sanitizedValue = target.value.replace(/\D/g, '');
                              //  setValue('customerCode', sanitizedValue);
                              setValue('customerCode', sanitizedValue, { shouldDirty: true, shouldValidate: true });
                              return;
                            }
                            setValue('customerCode', target.value);
                            dispatch(setDirty());
                          }}
                          onBlur={({ target }) => {
                            // setValue('customerCode', target.value.trim(), { shouldDirty: true });
                            setValue('customerCode', target.value.trim(), { shouldDirty: true, shouldValidate: true });
                          }}
                          value={watch('customerCode')}
                          disabled={disableFields}
                        />
                        <div className='invalid-feedback d-block'>
                          {errors.customerCode?.message?.toString()}
                        </div>

                        <div className='invalid-feedback d-block'>
                          {(country == 'VN') && watch('customerCode')?.trim().length > 0 && watch('customerCode')?.length < 8 && "Kindly enter your 8 digit customer code"}
                        </div>
                      </Form.Group>
                    </div>}

                  {((country == 'VN' || country == 'MZ') && selectedLinerId == '1') && (
                    <>
                      <div className='col-lg-4 mb-3'>
                        <Form.Group controlId='invoiceChanges.companyName'>
                          <Form.Label className='fs--1'>
                            <span className='mandatory'>*</span> {t('resource_2:companyName')}&nbsp;
                          </Form.Label>
                          <Form.Control
                            {...register('companyName')}
                            className={`fs--1 form-control ${errors.companyName ? 'is-invalid' : ''}`}
                            type='text'
                            maxLength={200}
                            onChange={({ target }) => {
                              setValue('companyName', target.value);
                              dispatch(setDirty());
                            }}
                            onBlur={({ target }) => {
                              setValue('companyName', target.value.trim())
                            }}
                            value={watch('companyName')}
                            disabled={disableFields}
                          />
                          <div className='invalid-feedback'>
                            {errors.companyName?.message?.toString()}
                          </div>
                        </Form.Group>
                      </div>

                      {/* Address */}
                      <div className='col-lg-4 mb-3'>
                        <Form.Group controlId='invoiceChanges.address'>
                          <Form.Label className='fs--1'>
                            <span className='mandatory'>*</span> {t('resource_1:address')}&nbsp;
                          </Form.Label>
                          <Form.Control
                            {...register('address')}
                            className={`fs--1 form-control ${errors.address ? 'is-invalid' : ''}`}
                            as='textarea'
                            rows={2}
                            maxLength={500}
                            onChange={({ target }) => {
                              setValue('address', target.value);
                              dispatch(setDirty());
                            }}
                            onBlur={({ target }) => {
                              setValue('address', target.value.trim(), { shouldDirty: true })
                            }}
                            value={watch('address')}
                            disabled={disableFields}
                          />
                          <div className='invalid-feedback'>
                            {errors.address?.message?.toString()}
                          </div>
                        </Form.Group>
                      </div>

                      {/* Email ID */}
                      <div className='col-lg-4 mb-3'>
                        <Form.Group controlId='invoiceChanges.emailId'>
                          <Form.Label className='fs--1'>
                            <span className='mandatory'>*</span> {t('resource_2:emailId')}&nbsp;
                          </Form.Label>
                          <Form.Control
                            {...register('emailId')}
                            className={`fs--1 form-control ${errors.emailId ? 'is-invalid' : ''}`}
                            type='email'
                            maxLength={100}
                            onChange={({ target }) => {
                              setValue('emailId', target.value);
                              dispatch(setDirty());
                            }}
                            onBlur={({ target }) => {
                              setValue('emailId', target.value.trim(), { shouldDirty: true })
                            }}
                            value={watch('emailId')}
                            disabled={disableFields}
                          />
                          <div className='invalid-feedback'>
                            {errors.emailId?.message?.toString()}
                          </div>
                        </Form.Group>
                      </div>

                      {/* TAX ID */}
                      <div className='col-lg-4 mb-3'>
                        <Form.Group controlId='invoiceChanges.taxId'>
                          <Form.Label className='fs--1'>
                            <span className='mandatory'>*</span> {t('resource_2:taxId')}&nbsp;
                          </Form.Label>
                          <Form.Control
                            {...register('taxId')}
                            className={`fs--1 form-control ${errors.taxId ? 'is-invalid' : ''}`}
                            type='text'
                            maxLength={50}
                            onChange={({ target }) => {
                              setValue('taxId', target.value);
                              dispatch(setDirty());
                            }}
                            onBlur={({ target }) => {
                              setValue('taxId', target.value.trim(), { shouldDirty: true })
                            }}
                            value={watch('taxId')}
                            disabled={disableFields}
                          />
                          <div className='invalid-feedback'>
                            {errors.taxId?.message?.toString()}
                          </div>
                        </Form.Group>
                      </div>
                    </>
                  )}
                  <div className='col-lg-4 mb-3'>
                    <Form.Group controlId='pickUpInstruction.userRemark'>
                      <Form.Label className='fs--1'>
                        {t('resource_2:userRemark')}
                      </Form.Label>
                      <Form.Control
                        className={'fs--1 form-control'}
                        {...register('userRemark')}
                        as='textarea'
                        onChange={(e) => { dispatch(setDirty()); setValue('userRemark', e.target.value, { shouldDirty: true }) }}
                        maxLength={100}
                        value={watch('userRemark')}
                        disabled={
                          disableFields
                        }
                      />
                    </Form.Group>
                  </div>

                  {profileDetails.partnerType === 'liner' ? <div className='col-lg-4 mb-3'>
                    <Form.Group controlId='invoiceChanges.requesterEmail'>
                      <Form.Label className='fs--1'>
                        {t('resource_2:requesterEmail')}&nbsp;
                      </Form.Label>
                      <Form.Control
                        {...register('requesterEmail')}
                        className={`fs--1 form-control ${errors.requesterEmail ? 'is-invalid' : ''
                          }`}
                        type='text'
                        maxLength={200}
                        onChange={({ target }) => {
                          {
                            setValue('requesterEmail', target.value, { shouldDirty: true });
                            dispatch(setDirty());
                          }
                        }}
                        value={watch('requesterEmail')}
                        disabled={true}
                      />
                      <div className='invalid-feedback'>
                        {errors.requesterEmail?.message?.toString()}
                      </div>
                    </Form.Group>
                  </div> : ""}


                  {(disableFields) && (
                    <div className='col-lg-4 mb-3'>
                      <Form.Group controlId='pickUpInstruction.rejectionRemark'>
                        <Form.Label className='fs--1'>
                          {t('resource_1:rejectRemark')}
                        </Form.Label>
                        <Form.Control
                          className={'fs--1 form-control'}
                          {...register('rejectRemarks')}
                          as='textarea'
                          onChange={(e) => { setValue('rejectRemarks', e.target.value, { shouldDirty: true }); dispatch(setDirty()); }}
                          //maxLength={150}
                          value={watch('rejectRemarks')}
                          disabled={
                            pickUpForm?.status === 'Completed' ||
                              pickUpForm?.status === 'Rejected' ||
                              profileDetails?.partnerType === 'customer'
                              ? true
                              : false
                          }
                        />
                      </Form.Group>
                    </div>
                  )}

                  {disableFields && (
                    <div className='col-lg-5 mb-3'>
                      <Form.Group controlId='invoiceChanges.status'>
                        <Form.Label className='fs--1'>
                          {t('resource_1:status')}&nbsp;
                        </Form.Label>
                        <Form.Control
                          className={'fs--1 form-control'}
                          type='text'
                          value={watch('status')}
                          disabled={true}
                        />
                      </Form.Group>
                    </div>
                  )}
                </div>
              </div>
              <>
                {profileDetails?.partnerType === 'liner'
                  ? extensionRequestStatus === 'Submitted' && rbac.rbacDetails.overStayApproveReject === 'Y'
                  && blCountry == dataCountry
                  && (
                    <>
                      <div className='d-flex justify-content-center align-items-center'>
                        <Button
                          disabled={
                            extensionRequestStatus === 'Completed' ||
                              extensionRequestStatus === 'Rejected'
                              ? disableFields
                              : false
                          }
                          onClick={(e) => {
                            onApproveReject('A', 'EXTENSION_REQUEST');
                          }}
                          variant='success'
                          className='me-2 approve'
                          size='sm'
                        >
                          <FontAwesomeIcon
                            icon={faCheck}
                            className='me-2 approve'
                          />
                          {t('resource_1:approve')}
                        </Button>

                        <Button
                          variant='danger'
                          className='reject me-2'
                          size='sm'
                          disabled={
                            extensionRequestStatus === 'Completed' ||
                              extensionRequestStatus === 'Rejected'
                              ? disableFields
                              : false
                          }
                          onClick={(e) => {
                            onApproveReject('R', 'EXTENSION_REQUEST');
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faTimes}
                            className='me-2 reject'
                          />
                          {t('resource_1:reject')}
                        </Button>
                        {rbac.rbacDetails.snoozeCUD === 'Y' && !location.pathname.includes('/bl') ? <SnoozedToButton blNum={AESDecrypt(blNum)} blEventId={blEventId_docInsDashboard} /> : ""}
                      </div>
                    </>


                  ) : (
                    ((!disabledPath &&
                      profileDetails?.partnerType === 'customer') || isEdit) && (
                      <div className='d-flex justify-content-center align-items-center'>
                        <Button
                          className='me-2'
                          variant='falcon-primary'
                          size='sm'
                          type='submit'
                          disabled={(() => {
                            const cc = String(watch('customerCode', '')).trim();
                            // Avoid this check for SA
                            // if (!cc && country !== 'SA' && && linerId !=='24118') return true;
                            /*  if (!cc && linerId !== '1') return true; */
                            const rows = Array.isArray(data?.list) ? data.list : Array.isArray(data) ? data : [];
                            if (rows.length === 0) return true;
                            const submittedGeneric = rows.filter((r: any) => r.needExtensionFor !== '0' && r.needExtensionFor !== 0);
                            if (submittedGeneric.length < 1) return true;


                            if (submittedGeneric.some((r: any) => !r.plannedPickupDate)) return true;
                            // Check for container data first
                            if ((country == 'VN' || country == 'MZ') && watch("customerCode")?.trim().length > 0 && watch("customerCode")?.length < 8) {
                              return true;
                            }
                            if (['KE', 'TG','CI', 'UG', 'TZ', 'MZ', 'VN', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118') || (blCountry == 'CM' && selectedLinerId == '24118') || (blCountry == 'CG' && selectedLinerId == '24118')) {
                              const submitted = data?.filter((item: any) => item.needExtensionFor !== "0" && item.needExtensionFor !== 0);
                              if (submitted.length < 1) return true;
                              
                              if (blCountry === 'ZA' && selectedLinerId === '24118') {
                                if (submitted.some((item: any) =>
                                  !item.containerReturnDate ||
                                  !item.returnLocation ||
                                  item.returnLocation === '0'
                                )) {
                                  return true;
                                }
                              }

                              // Check country-specific requirements
                              if (country !== 'VN' && country !== 'MZ' && country !== 'CM' && country !=='TG' && country !== 'CI' && country !== 'BJ' && country !== 'LK' && selectedLinerId != "1" ) {
                                if (submitted.some((item: any) =>                   
                                  !item.plannedPickupDate ||
                                  !item.deliveryLocationType ||
                                  item.deliveryLocationType === '0' ||
                                  !item.currency
                                )) {
                                  return true;
                                }
                              }                      
                             /*  if(country==='TG','CI'){
                                if (submitted.some((item: any) =>
                                  !item.currency
                                )) {
                                  return true;
                                }

                              } */
                              if (country == 'VN' || country == 'MZ' || country == 'CM' || country == 'KE') {
                                if (submitted.some((item: any) =>
                                  !item.plannedPickupDate
                                )) {
                                  return true;
                                }
                              }

                              // Check mandatory fields for VN country
                              if (country === 'VN' || country === 'MZ') {
                                const mandatoryFields = [
                                  watch('companyName')?.trim(),
                                  watch('address')?.trim(),
                                  watch('emailId')?.trim(),
                                  watch('taxId')?.trim()
                                ];
                                if (mandatoryFields.some((val) => !val)) {
                                  return true;
                                }
                              }



                              // // Check customer code for non-liner
                              // if (watch('customerCode')?.trim() === '' && linerId !== '1' && country !== 'SA' && country !=='CM','CG' && country!=='TG','CI' && country !=='KE'  ) {
                              //   return true;
                              // }  

                              if (linerId === '24118') {
                                const alphanumericRegex = /^[A-Za-z0-9]*$/;
                                if (!alphanumericRegex.test(watch('customerCode')?.trim() || '')) {
                                  return true;
                                }
                              }

                              return false;
                            }
                            return false;
                          })()}

                        >
                          <FontAwesomeIcon icon={faSave} className='me-2' />
                          {t('resource_1:submit')}
                        </Button>

                        <Button
                          className='me-2'
                          variant='falcon-danger'
                          size='sm'
                          onClick={resetForm}
                        >
                          <FontAwesomeIcon icon={faRedo} className='me-2' />
                          {t('resource_1:reset')}
                        </Button>
                      </div>
                    )
                  )}
              </>
              <div className='d-flex justify-content-center align-items-center'>
                {extensionRequestStatus === 'Submitted' && disableFields && profileDetails?.partnerType === 'customer' && <Button
                  variant='falcon-primary'
                  size='sm'
                  className='me-2'
                  onClick={() => {
                    setIsEdit(true);
                  }}>
                  <FontAwesomeIcon icon={faEdit} className='me-2' />
                  {t('resource_1:edit')}
                </Button>}
              </div>
            </div>
          </Form>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OverstayExtensionRequest;
